export const POPOVER_OPEN_DELAY = 200;
export const POPOVER_PLACEMENT = ['top', 'bottom', 'left', 'right'];
